const tabsSteps = document.querySelectorAll('.tabs-steps')

const changeTab = (item, singleTabsSteps) => {
	const tabsContent = singleTabsSteps.querySelectorAll('.step-tab-content')
	const tabsNums = singleTabsSteps.querySelectorAll('.step-tab-num')

	clearActiveClasses(tabsContent, 'is-active')
	clearActiveClasses(tabsNums, 'is-active')

	const numElem = item.closest('.step-tab-num')

	if (numElem) {
		numElem.classList.add('is-active')
		tabsContent.forEach(tabContent => {
			if (tabContent.dataset.tab == numElem.dataset.tab) {
				tabContent.classList.add('is-active')
			}
		})
	}
}

const clearActiveClasses = (items, ...classes) => {
	items.forEach(item => item.classList.remove(...classes))
}

tabsSteps.forEach(singleTabsSteps => {
	singleTabsSteps.addEventListener('click', e => {
		if (e.target.closest('.step-tab-num')) {
			changeTab(e.target, singleTabsSteps)
		}
	})
})
